module.exports = require('./govobject');

module.exports.Proposal = require('./types/proposal');
module.exports.Trigger = require('./types/trigger');
